import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import score from 'src/helper/score2'
import lang from '../lang'
import {jumpToUser, jumpToRoom} from 'src/helper/webviewFun'

export default class extends React.Component {
  state = {}

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  top3 = (language, list, type,myrank) => {
    return (
      <div className={`top3`}>
        {list &&
          list.length > 0 &&
          list.map((item, index) => {
            if (index < 3) {
              return (
                <div  className={`user user${index + 1}`} onClick={jumpToUser.bind(this, item.uid)}>
                  {/* <img
                    onClick={jumpToUser.bind(this, item.uid)}
                    className={`kuan kuan${index + 1}`}
                    src={`/img/activity/22-09-22ksa/y${index + 1}.png`}
                  /> */}
                  <img                  
                    className={`avatarurl avatarurl${index + 1}`}
                    src={cdn(item.avatarurl)}
                  />
                  <div className={`nickname nickname${index + 1}`}>{item.nickname ? item.nickname : ''}</div>
                  <div className={`did did${index + 1}`}><img src="/img/activity/202408tr/coin.png"/>{item.score ? score(item.score) : 0}</div>
                  {/* <div className={`score score${index + 1}`}>{item.score}</div>                   */}
                  <img                  
                  className={`head head${index + 1}`}
                    src={`/img/activity/202408tr/top${index + 1}_f.png`}
                  />
                </div>
              )
            }
          })}
      </div>
    )
  }

  render() {
    let { language, list, lang ,myrank} = this.props
    return (
      <div className="userList">
        <div className="listTop">Top 1-3</div>
        <div className="bd">
          <div className={`list ${language == 'ar' && 'arlang'}`}>
            <div className={`listuser ${language == 'ar' && 'arlang'}`}>
              {/* <div style={{ height: '1rem' }}></div> */}
              {/* <div className="listnotice">{lang.notice}</div> */}
              <div style={{ height: '2.3rem' }}></div>
              {this.top3(language, list)}
              <div className='list-box'>
              {list &&
                list.length > 0 &&
                list.map((item, index) => {
                  // console.log(111, item)
                  if (index > 2) {
                    return (
                      <div 
                        className={`${
                          'userinfo item_bg' + ((index % 2) + 1) + ' ' + (item.isMine == true ? 'item_bg3' : '')
                        } `}
                        onClick={jumpToUser.bind(this, item.uid)}
                      >
                        <div className="rank" onClick={jumpToUser.bind(this, item.uid)}>
                          {index == 0 && <img src={'/img/activity/dayiraq/img/r1.png'} />}
                          {index == 1 && <img src={'/img/activity/dayiraq/img/r2.png'} />}
                          {index == 2 && <img src={'/img/activity/dayiraq/img/r3.png'} />}
                          {/* {index > 2 && index > 19 && '20+'} */}
                          {item.rankIdx}
                        </div>
                        <img className={`man2 ${language == 'ar' && 'arlang'}`} src={'/img/activity/202408tr/man2.png'} />
                        <div className={`userlogo`} title={item.uid} >
                          <img                          
                            src={cdn(item.avatarurl)}
                          />
                        </div>
                        <div style={{ width: '0.3rem' }}></div>
                        <div className="nickname">
                          <div className={`${'nickname1'}`}>{item ? item.nickname : ''}</div>
                          <div className={`${'nickname2'}`}>
                            ID: {item ? item.duid : ''}
                            {item.isMine}
                          </div>
                        </div>
                        <div className="itemRight">
                          <div className="scoreicon">
                            <img src="/img/activity/202408tr/coin.png"/>
                            <div className="score">{score(item.score)} </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                })}
                
                      
                <div className="copyright">
        <div className="ti">
          {lang.copyright}
        </div>
      </div>
              </div>
            </div>
          </div>
        </div>
        <div className="listBottom">
        <div  className="userinfo item_bg7 myrank">
                        <div className="rank">
                          {myrank.rankIdx == 0 ? "20+" : myrank.rankIdx}
                        </div>
                        <div className={`userlogo`} title={myrank.uid}>
                          <img
                          onClick={jumpToUser.bind(this, myrank.uid)}
                            src={cdn(myrank.avatarurl)}
                          />
                        </div>
                        <div style={{ width: '0.3rem' }}></div>
                        <div className="nickname">
                          <div className={`${'nickname1'}`}>{myrank ? myrank.nickname : ''}</div>
                          <div className={`${'nickname2'}`}>
                            ID: {myrank ? myrank.duid : ''}
                            {myrank.isMine}
                          </div>
                        </div>
                        <div className="itemRight">
                          <div className="scoreicon">
                            <img src="/img/activity/202408tr/coin.png"/>
                            <div className="score">&nbsp;{score(myrank.score)}&nbsp;</div>
                          </div>
                        </div>
                        <img className={`man2 ${language == 'ar' && 'arlang'}`} src={'/img/activity/202408tr/man2.png'} />
                      </div>
        </div>
        
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/202408tr/List/index.js